
import { Transaction } from "@/types";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TransactionList } from "./TransactionList";

interface TransactionTabsProps {
  transactions: Transaction[];
  isAdmin: boolean;
  onTransactionDeleted: () => void;
}

export function TransactionTabs({ transactions, isAdmin, onTransactionDeleted }: TransactionTabsProps) {
  // transactions arrive sorted desc by createdAt; the first is the latest overall
  const latestTransactionId = transactions[0]?.id;

  return (
    <Tabs defaultValue="all" className="w-full">
      <TabsList className="mb-4">
        <TabsTrigger value="all">All Transactions</TabsTrigger>
        <TabsTrigger value="deposits">Deposits</TabsTrigger>
        <TabsTrigger value="withdrawals">Withdrawals</TabsTrigger>
      </TabsList>
      
      <TabsContent value="all">
        <TransactionList 
          transactions={transactions} 
          isAdmin={isAdmin}
          latestTransactionId={latestTransactionId}
          onTransactionDeleted={onTransactionDeleted}
        />
      </TabsContent>
      
      <TabsContent value="deposits">
        <TransactionList
          transactions={transactions.filter((t) => t.amount > 0)}
          isAdmin={isAdmin}
          latestTransactionId={latestTransactionId}
          onTransactionDeleted={onTransactionDeleted}
        />
      </TabsContent>
      
      <TabsContent value="withdrawals">
        <TransactionList
          transactions={transactions.filter((t) => t.amount < 0)}
          isAdmin={isAdmin}
          latestTransactionId={latestTransactionId}
          onTransactionDeleted={onTransactionDeleted}
        />
      </TabsContent>
    </Tabs>
  );
}
